export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20angle%20view%20of%20a%20bright%20airy%20modern%20creative%20studio%20workspace%20with%20a%20large%20iMac%20displaying%20colorful%20organized%20spreadsheet%20dashboard%20with%20product%20cards%20and%20charts%2C%20surrounded%20by%20design%20magazines%20fabric%20swatches%20and%20a%20ceramic%20vase%20with%20dried%20flowers%2C%20warm%20natural%20daylight%20flooding%20through%20large%20windows%2C%20soft%20cream%20walls%2C%20light%20oak%20flooring%2C%20clean%20Scandinavian%20minimal%20aesthetic%2C%20soft%20diffused%20shadows%2C%20editorial%20interior%20photography%2C%20high%20detail%2C%20harmonious%20balanced%20composition%2C%20fresh%20inspiring%20atmosphere&width=1800&height=900&seq=hero-bg-v2&orientation=landscape"
          alt="Vigorbuy Spreadsheet workspace"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-6 flex flex-wrap items-center justify-center gap-3">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium">
            <i className="ri-checkbox-circle-fill text-sm"></i>
            Updated 2026
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium">
            <i className="ri-shield-check-fill text-sm"></i>
            Trusted Resource
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium">
            <i className="ri-guide-fill text-sm"></i>
            Beginner Friendly
          </span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Vigorbuy Spreadsheet
          <br />
          <span className="text-accent-300">The Ultimate Product Research Database</span>
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover the latest Vigorbuy Spreadsheet collections, product guides, category comparisons and shopping resources. Find better products faster with organized spreadsheets, detailed explanations and expert buying guides.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-lg"></i>
            Vigorbuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold text-base hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-right-up-line text-lg"></i>
            Explore Categories
          </a>
        </div>
      </div>
    </section>
  );
}